import React, { Component } from 'react';
import TdLink from './TdLink';
import { AppService } from '@aperza/util';
const appConfig = AppService.appConfig();
export default class AppLinkContainer extends Component {
    render() {
        return (React.createElement("div", { className: "app-link-container" },
            React.createElement(TdLink, { action: "goto-aperza", href: `https://www${appConfig.baseDomain}`, anchorText: "Aperza", openOnNewTab: true },
                "Aperza ",
                React.createElement("i", { className: "fa fa-external-link", "aria-hidden": "true" })),
            appConfig.isAperzaCatalogTop && (React.createElement(React.Fragment, null,
                React.createElement("div", null, "|"),
                React.createElement(TdLink, { action: "goto-aperza-cloud", href: `https://dx${appConfig.baseComDomain}/home/index.html`, anchorText: "Ap\u00E9rza DX", openOnNewTab: true },
                    "Ap\u00E9rza DX ",
                    React.createElement("i", { className: "fa fa-external-link", "aria-hidden": "true" }))))));
    }
}
